export function notifyUser(title) {
  if (!('Notification' in window)) {
    return;
  } else if (Notification.permission === 'granted') {
    var notification = new Notification(title);
  } else if (Notification.permission !== 'denied') {
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        var notification = new Notification(title);
      }
    });
  }
}
